module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.vehicle) ? _c('div', {
    staticClass: "component-tabbed-vehicle-map-position"
  }, [_c('div', {
    staticClass: "action-bar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Vehicle Position " + _vm._s(_vm.vehicle.vehicle_slot_address) + "  " + _vm._s(_vm.vehicle.has_reservation ? ' - ' + _vm.vehicle.has_reservation : ''))])])]), _c('div', {
    staticClass: "wrap"
  }, [_c('GoogleMapContainer', [_c('GoogleMap', {
    attrs: {
      "center": {
        lat: _vm.vehicle.position.latitude,
        lng: _vm.vehicle.position.longitude
      },
      "api-key": _vm.mapsAPI,
      "searchBar": true,
      "zoom": 17,
      "zoomControl": true,
      "mapTypeControl": true
    }
  }, [_c('GoogleMapMarker', {
    attrs: {
      "position": {
        lat: _vm.vehicle.position.latitude,
        lng: _vm.vehicle.position.longitude
      },
      "title": _vm.vehicle.model,
      "label": _vm.vehicle.model,
      "icon": _vm.vehicleInRange(_vm.vehicle)
    }
  }), _c('GoogleMapCircle', {
    attrs: {
      "position": {
        lat: _vm.vehicle.parking_lot.position.latitude,
        lng: _vm.vehicle.parking_lot.position.longitude
      }
    }
  })], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00458155!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleMapPosition.vue
// module id = 2089
// module chunks = 1